module.exports = __webpack_public_path__ + "media/images/icons/country_flags/fi-ead68a19c50e3e6f4d042ec0715faf1e.svg";